/** @typedef {'ladies' | 'gents'} BookPricingGender */

export const BOOK_GENDER_TOGGLE_OPTIONS = [
  { value: 'ladies', label: 'L', titleKey: 'pos.ladies' },
  { value: 'gents', label: 'G', titleKey: 'pos.gents' },
]

/**
 * @param {number | string | null | undefined} value
 */
export function toPosAmount(value) {
  if (value === null || value === undefined || value === '') return 0
  const parsed = Number(value)
  return Number.isFinite(parsed) ? parsed : 0
}

/**
 * @param {{ price_ladies?: number | string, price_gents?: number | string, price?: number | string }} service
 * @param {BookPricingGender} gender
 */
export function resolveBookServicePrice(service, gender) {
  if (gender === 'gents') {
    return toPosAmount(service.price_gents)
  }

  return toPosAmount(service.price_ladies ?? service.price)
}

/**
 * @param {{ price_ladies?: number | string, price_gents?: number | string, price?: number | string }} service
 * @param {BookPricingGender} gender
 */
export function serviceBookableForGender(service, gender) {
  const amount = resolveBookServicePrice(service, gender)
  return Number.isFinite(amount) && amount > 0
}

/**
 * Public booking catalog from `/public/booking/{slug}/config` — not the POS masters shape.
 *
 * @param {Array<{ id: number, gender_scope?: string, services?: Array<Record<string, unknown>> }>} categories
 * @param {BookPricingGender} gender
 */
export function filterCategoriesForBooking(categories, gender) {
  return categories
    .map((category) => {
      const scope = category.gender_scope ?? 'all'
      if (scope !== 'all' && scope !== gender) {
        return null
      }

      const services = (category.services ?? []).filter((service) =>
        serviceBookableForGender(service, gender),
      )

      if (services.length === 0) {
        return null
      }

      return { ...category, services }
    })
    .filter(Boolean)
}

/**
 * @param {BookPricingGender} gender
 * @param {string | null | undefined} slug
 */
export function readStoredBookPricingGender(gender, slug) {
  if (gender === 'ladies' || gender === 'gents') {
    return gender
  }

  if (!slug || typeof window === 'undefined') {
    return 'ladies'
  }

  const stored = window.sessionStorage.getItem(`book:pricing-gender:${slug}`)
  return stored === 'gents' ? 'gents' : 'ladies'
}

/**
 * @param {string | null | undefined} slug
 * @param {BookPricingGender} gender
 */
export function storeBookPricingGender(slug, gender) {
  if (!slug || typeof window === 'undefined') {
    return
  }

  window.sessionStorage.setItem(`book:pricing-gender:${slug}`, gender)
}
